import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Mail } from 'lucide-react';

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-aurika-obsidian text-aurika-bone">
            <div className="container-editorial pt-24 pb-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <p className="overline text-aurika-ochre">Aurika Collective Foundation</p>
                        <h3 className="font-display text-4xl md:text-5xl font-light mt-4 leading-[1.05] text-balance">
                            Together we create opportunities.
                        </h3>
                        <p className="mt-6 text-aurika-bone/70 max-w-md font-light">
                            Building a world where everyday experiences — how we travel, gather, volunteer and celebrate — create meaningful, measurable impact.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <p className="overline text-aurika-ochre/80">Explore</p>
                        <ul className="mt-5 space-y-3 text-sm">
                            <li><Link to="/about" className="hover:text-aurika-ochre transition-colors">About Aurika</Link></li>
                            <li><Link to="/verticals/agritourism" className="hover:text-aurika-ochre transition-colors">Agritourism</Link></li>
                            <li><Link to="/verticals/gatherings" className="hover:text-aurika-ochre transition-colors">Gatherings</Link></li>
                            <li><Link to="/verticals/volunteering" className="hover:text-aurika-ochre transition-colors">Volunteering</Link></li>
                            <li><Link to="/verticals/campaigns" className="hover:text-aurika-ochre transition-colors">Impact Campaigns</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <p className="overline text-aurika-ochre/80">Get in touch</p>
                        <ul className="mt-5 space-y-3 text-sm text-aurika-bone/80">
                            <li className="flex items-center gap-3"><Mail size={14} /> aurika.foundation@gmail.com</li>
                            <li>Delhi, India</li>
                            <li>Phone no. +91-9999083360</li>
                        </ul>
                        <div className="mt-8 flex items-center gap-4">
                            <a href="#" aria-label="Instagram" className="p-2 border border-aurika-bone/20 hover:border-aurika-ochre hover:text-aurika-ochre transition-colors">
                                <Instagram size={16} />
                            </a>
                            <a href="#" aria-label="LinkedIn" className="p-2 border border-aurika-bone/20 hover:border-aurika-ochre hover:text-aurika-ochre transition-colors">
                                <Linkedin size={16} />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-20 pt-8 border-t border-aurika-bone/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-aurika-bone/60">
                    <p>© {new Date().getFullYear()} Aurika Collective Foundation. Crafted in Bharat.</p>
                    <p className="font-mono-brand tracking-wide">Registered under Sec. 8, Companies Act — CSR eligible.</p>
                </div>
            </div>
        </footer>
    );
}
